<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card 
                    title="Files ricevuti" 
                    :subtitle="sharedStore.receivedFiles.length" 
                    class="pa-2" 
                    flat
                >
                    <v-card-text>
                        <v-list lines="two">
                            <v-list-item 
                                v-for="item in sharedStore.receivedFiles" 
                                :key="item.name + item.size" 
                                :title="item.name"
                                :subtitle="`${item.type} | Campo: ${item.target}`" 
                                class="mb-2 rounded-lg elevation-1"
                                density="comfortable">
                                <template v-slot:append>
                                    <v-chip 
                                        color="indigo" 
                                        variant="flat">
                                        {{ formatBytes(item.size) }}
                                    </v-chip>
                                </template>
                            </v-list-item>
                        </v-list>
                        <!-- A seconda dell'estensione, proporre/ agire<br>
                        Non acora implementato. -->

                        {{ JSON.stringify(sharedStore.receivedPayload) }}


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>

import { ref } from 'vue';

import { useSharedStore } from "@/store/shared"


// receivedPayload is for debug only, to see the entire payload received from the service worker, including text, url, title, etc. It can be used in the future to implement more complex logic based on the content of the share.

const sharedStore = useSharedStore()

function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

</script>
